import { Tooltip, TooltipProps } from '../../../../../BaseComponents';
import React, { FC } from 'react';

const WithTooltip: FC<TooltipProps> = ({ title, children, ...props }) => {
	return !!title ? (
		<Tooltip title={title} {...props}>
			{children}
		</Tooltip>
	) : (
		children
	);
};

export default WithTooltip;
